import { GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
export const getEXSTServices = (services) => services.filter(service => service.rfisc === 'EXST' &&
    service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
    (service === null || service === void 0 ? void 0 : service.subType) ===
        GdsServiceVipSubType.ExtraSeat);
